export default "__VITE_ASSET__b7e102ec__"